<template>
  <transition name="modal">
    <div :class="$style.modal" v-if="activeModal">
      <div :class="$style.backdrop" @click="close"></div>

      <div :class="$style.contentWrapper">
        <div
          :class="{
            [$style.content]: true,
            [$style[activeModal]]: !!$style[activeModal],
          }"
        >
          <div :class="$style.header">
            <div
              :class="$style.resetImage"
              v-if="['MobileCanvas1', 'MobileCanvas2'].includes(activeModal)"
              @click="resetImage"
            >
              Reset image
            </div>

            <a
              v-if="
                ['MobileCanvas1', 'MobileCanvas2', 'Canvas'].includes(
                  activeModal
                )
              "
              :class="$style.canvasButton"
              href="https://www.vdrsizesuggestion.com/shopify/test/directions.html"
              target="_blank"
              >Instructions</a
            >

            <button
              v-if="activeModal == 'Main'"
              @click="setActiveModal(isMovile ? 'MobileCanvas1' : 'Canvas')"
              :class="[$style.canvasButton, $style.fitting]"
            >
              <img src="../../assets/focus_24.png"/>&nbsp; Virtual
              Fitting {{test}}
            </button>
            <div :class="$style.close" @click="close"></div>
          </div>

          <div :class="$style.childContent">
            <component
              :is="activeModal"
              @setActiveModal="setActiveModal"
              @title="title = $event"
              @headerAction="header = $event"
              @prevLink="prevLink = $event"
              @nextLink="nextLink = $event"
              @hook:beforeDestroy="clearAll"
            />
          </div>

          <div :class="$style.links" v-if="activeModal == 'Main'">
            <a href="https://apps.shopify.com/size-suggestion-tool-prod">
              Powered by <img :src="modi"/>
            </a>
            <a href="https://vdrsizesuggestion.com/privacy/" target="_blank">
              Privacy
            </a>
          </div>
          <div :class="$style.footer" v-if="prevLink || nextLink">
            <div :class="$style.footerCol">
              <Button
                v-if="prevLink"
                :class="$style.button"
                @click="setActiveModal(prevLink)"
                >Back</Button
              >
            </div>
            <div :class="$style.footerCol">
              <Button v-if="nextLink" :class="$style.button" @click="nextScreen"
                >Next</Button
              >
            </div>
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
import { mapState, mapMutations, mapActions } from "vuex";

import Button from "@/components/lib/Button";

import Main from "./Main";
import LogIn from "./LogIn";
import Register from "./Register";
import Canvas from "./Canvas";
import Chart from "./Chart";

import MobileCanvas1 from "./mobile/Canvas1.vue";
import MobileCanvas2 from "./mobile/Canvas2.vue";
import MobileCanvasInput from "./mobile/CanvasInput.vue";
import MobileCanvasOutput from "./mobile/CanvasOutput.vue";

export default {
  components: {
    Button,

    Main,
    LogIn,
    Register,
    Canvas,
    Chart,

    MobileCanvas1,
    MobileCanvas2,
    MobileCanvasInput,
    MobileCanvasOutput,
  },
  data() {
    return {
      title: null,
      prevLink: null,
      nextLink: null,
      modi: `https://vdrsizesuggestion.com/shopifyMobile/assets/modi.svg'`,
      isMovile: window.innerWidth < 768,
    };
  },
  computed: mapState(["activeModal"]),
  methods: {
    ...mapActions(["submitCanvasInput"]),
    ...mapMutations([
      "closeModal",
      "setActiveModal",
      "showPrevModal",
      "resetImage",
    ]),

    async nextScreen() {
      if (!this.nextLink) {
        return;
      }

      if (this.nextLink === "MobileCanvasOutput") {
        await this.submitCanvasInput();
      }
      this.setActiveModal(this.nextLink);
    },

    close() {
      if (this.activeModal == "Main") {
        this.closeModal();
      } else {
        this.setActiveModal("Main");
      }
    },

    clearAll() {
      this.title = null;
      this.prevLink = null;
      this.nextLink = null;
    },

    onResize() {
      if (window.innerWidth < 768 && ["Canvas"].includes(this.activeModal)) {
        this.setActiveModal("MobileCanvas1");
      } else if (
        window.innerWidth >= 768 &&
        [
          "MobileCanvas1",
          "MobileCanvas2",
          "MobileCanvasInput",
          "MobileCanvasOutput",
        ].includes(this.activeModal)
      ) {
        this.setActiveModal("Canvas");
      }
      this.isMovile = window.innerWidth < 768
    },
  },
  mounted() {
    window.addEventListener("resize", this.onResize);
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.onResize);
  },
};
</script>

<style lang="scss" module>
$gray: #cccccd;
$dark: #262626;

.modal {
  display: block;
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: 999;
}

.backdrop {
  display: block;
  position: absolute;
  width: 100vw;
  height: 100vh;
  background-color: #eaecee70;
}

.contentWrapper {
  height: 100%;
  display: flex;

  @media (min-width: 768px) {
    overflow-y: auto;
  }
}

.content {
  position: relative;
  z-index: 999;
  margin: auto;
  height: 100%;
  width: 100%;
  background-color: #fff;
  padding: 15px;
  display: flex;
  flex-direction: column;

  @media (min-width: 768px) {
    width: 80vw;
    max-width: 600px;
    border-radius: 0px;
    height: auto;
  }
}

.modal-enter-active,
.modal-leave-active {
  transition: opacity 0.5s;
}
.modal-enter,
.modal-leave-to {
  opacity: 0;
}

.Canvas {
  max-width: 80vw;
}

.canvasButton {
  background: transparent;
  border: none;
  text-decoration: none;
  color: $dark;
  padding: 0;

  &:hover {
    color: $gray;
  }
}

.fitting {
  padding: 8px 0 0 8px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.childContent {
  margin: 0 35px;
  flex-grow: 1;
}

.header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  position: relative;
  
  @media (max-width: 768px) {
    padding-bottom: 15px;
  }
}

.resetImage {
  font-size: 12px;
  color: rgb(39, 120, 173);
  cursor: pointer;
  width: 25%;
  text-align: left;
}

.closeWrapper {
  width: 25%;
  display: flex;
  justify-content: flex-end;
}

.close {
  cursor: pointer;
  height: 15px;
  width: 15px;
  background-image: url(data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iaXNvLTg4NTktMSI/PjxzdmcgdmVyc2lvbj0iMS4xIiBpZD0iQ2FwYV8xIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5L3hsaW5rIiB4PSIwcHgiIHk9IjBweCIgdmlld0JveD0iMCAwIDQ3Ljk3MSA0Ny45NzEiIHN0eWxlPSJlbmFibGUtYmFja2dyb3VuZDpuZXcgMCAwIDQ3Ljk3MSA0Ny45NzE7IiB4bWw6c3BhY2U9InByZXNlcnZlIj48Zz48cGF0aCBkPSJNMjguMjI4LDIzLjk4Nkw0Ny4wOTIsNS4xMjJjMS4xNzItMS4xNzEsMS4xNzItMy4wNzEsMC00LjI0MmMtMS4xNzItMS4xNzItMy4wNy0xLjE3Mi00LjI0MiwwTDIzLjk4NiwxOS43NDRMNS4xMjEsMC44OGMtMS4xNzItMS4xNzItMy4wNy0xLjE3Mi00LjI0MiwwYy0xLjE3MiwxLjE3MS0xLjE3MiwzLjA3MSwwLDQuMjQybDE4Ljg2NSwxOC44NjRMMC44NzksNDIuODVjLTEuMTcyLDEuMTcxLTEuMTcyLDMuMDcxLDAsNC4yNDJDMS40NjUsNDcuNjc3LDIuMjMzLDQ3Ljk3LDMsNDcuOTdzMS41MzUtMC4yOTMsMi4xMjEtMC44NzlsMTguODY1LTE4Ljg2NEw0Mi44NSw0Ny4wOTFjMC41ODYsMC41ODYsMS4zNTQsMC44NzksMi4xMjEsMC44NzlzMS41MzUtMC4yOTMsMi4xMjEtMC44NzljMS4xNzItMS4xNzEsMS4xNzItMy4wNzEsMC00LjI0MkwyOC4yMjgsMjMuOTg2eiIvPjwvZz48Zz48L2c+PGc+PC9nPjxnPjwvZz48Zz48L2c+PGc+PC9nPjxnPjwvZz48Zz48L2c+PGc+PC9nPjxnPjwvZz48Zz48L2c+PGc+PC9nPjxnPjwvZz48Zz48L2c+PGc+PC9nPjxnPjwvZz48L3N2Zz4=);
  opacity: 0.8;
  transition: 0.2s;

  &:hover {
    opacity: 1;
  }
}

.footer {
  display: flex;
  gap: 15px;

  @media (min-width: 768px) {
    display: none;
  }
}

.footerCol {
  width: 50%;
  padding-top: 15px;
}

.links {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  font-size: small;

  a {
    color: $gray;
    text-decoration: none;
    &:hover {
      color: $dark;
    }
  }
}

.button {
  display: block;
  width: 100%;
  border: 0;
  outline: 0;
  padding: 10px;
  background-color: rgb(0, 0, 0);
  color: #fff;
  cursor: pointer;
  transition: 0.2s;

  &:hover {
    background-color: rgb(34, 34, 34);
  }
}
</style>
